/**
 * Centralized query key factory for type safety and consistency
 * All query keys should be defined here to ensure proper cache invalidation
 */
export const queryKeys = {
	conversations: {
		/** Root key for invalidating ALL conversation pages */
		root: ['conversations'] as const,
		/** Key for paginated conversations - includes page and pageSize for cache separation */
		paginated: (page: number, pageSize: number) => ['conversations', { page, pageSize }] as const,
		detail: (id: string) => ['conversations', id] as const
	},
	publicConversations: {
		detail: (id: string) => ['publicConversations', id] as const,
		messages: (id: string) => ['publicConversations', id, 'messages'] as const
	},
	messages: {
		byConversation: (conversationId: string) => ['messages', conversationId] as const,
		details: (messageId?: string) => ['messages', 'details', messageId] as const
	},
	dataPool: {
		byConversation: (conversationId: string) => ['dataPool', conversationId] as const
	},
	identity: {
		byAddress: (address: string) => ['identity', address] as const
	}
} as const;
